import { NAV_NAMES } from '../constants/nav-names';
import { NavLinkType } from './types';

export const LOGO: NavLinkType = {
  menuName: NAV_NAMES.LOGO,
  menuItems: [],
};
